import React from 'react';

const PlusMinus = ({stroke="secondary", val=true}) => {
    return(<svg width="22" strokeWidth="6" viewBox="0 0 100 100" stroke={`var(--c-${stroke})`}>
    {!!val && <path className="vertical" d="M50 0 L 50 100"/>}
    <path d="M0 50 L 100 50"/>
</svg>)
}

export default PlusMinus;